module.exports = __webpack_public_path__ + "static/4m-89254b935ead208fa549df063c0d5812.jpg";